











import Openable from '@/global/viewmodels/openable'
import mixins from 'vue-typed-mixins'

enum types {
    alert,
    prevent,
    error,
    info,
    success,
    title
}

export default mixins().extend({
    props: {
        alert: { type: Openable },
        type: { type: String, default: 'info' },
        title: { type: String, default: '' },
        text: { type: String, default: '### Text ###' },
        timer: { type: Number, default: 0 }
    },
    data() {
        return { types, currentTime: 0 }
    },
    mounted() {
        if (this.timer != 0) this.timeOut()
    },
    methods: {
        closeAlert() {
            this.alert.close()
        },
        timeOut() {
            setTimeout(() => {
                this.currentTime += 100
                if (this.timer <= this.currentTime) {
                    setTimeout(() => {
                        this.closeAlert()
                        this.currentTime = 0
                    }, 1000)
                } else {
                    //Recursivly update the progress bar
                    this.timeOut()
                }
            }, 100)
        }
    },
    watch: {
        value(v) {
            if (v) this.timeOut()
        }
    }
})
